<template>
  <div class="store-list">
    <div class="header" @click="toStoreList">
      <span class="title"
        >适用门店
        <span class="count" v-if="total > 2">（{{ total }}）</span>
      </span>
      <span class="toAll" v-if="total > 2">
        全部
        <van-icon name="arrow" />
      </span>
    </div>
    <div class="address" v-for="item in storeList" :key="item.id">
      <bm-storeAddress :source="1" :data="item" :reserve="Boolean(item.neededBook)" />
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex'
export default {
  props: {
    bid: String, //business id
    logo: String,
    name: String,
    pid: String,
    areaIds: {
      type: Array,
      default: () => {
        return []
      },
      commit: '有该商品的门店涵盖的所有区域'
    }
  },
  data() {
    return {
      iconUrl: process.env.VUE_APP_baseStaticUrl + 'icon/common/',
      storeList: [],
      page: 1,
      total: 0,
      load: false,
      isMore: true
    }
  },
  computed: {
    ...mapGetters({
      location: 'common/sys/location'
    })
  },
  watch: {
    pid(v) {
      this.getStore()
    }
  },
  mounted() {
    this.getStore()
  },
  methods: {
    toStoreList() {
      this.$router.push(`/product/${this.$route.params.id}/storeList?areaIds=${JSON.stringify(this.areaIds)}`)
    },
    linkToShop() {
      this.$router.push({
        path: '/shop/detail',
        query: {
          id: this.bid
        }
      })
    },
    getStore(page = 1) {
      this.load = true
      if (!this.pid || this.pid === 'undefined') {
        this.load = false
        return
      }
      this.$api.search
        .getStoreByProduct({
          pid: this.pid,
          lat: this.location.lat,
          lon: this.location.lon,
          size: 2,
          page
        })
        .then(res => {
          let list = this.storeList
          this.total = res.total
          if (page === 1) list = []
          res.list.map(item => {
            item.distance = Math.round(item.distance * 100) / 100
          })
          this.storeList = [...list, ...res.list]
          this.page = page
          this.load = false
          this.isMore = page * res.size < res.total
        })
        .finally(() => (this.load = false))
    },
    loadMore() {
      if (this.isMore && !this.load) {
        this.getStore(this.page + 1)
      }
    }
  }
}
</script>

<style lang="less" scoped>
.store-list {
  position: relative;
  z-index: 9;
  padding: 15px 0;
  padding-bottom: 0;
  box-sizing: border-box;
  background-color: #fff;
  border-bottom: 15px solid #f5f5f5;
  box-sizing: border-box;
  overflow: hidden;
  .header {
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    margin-bottom: 9px;
    padding: 0 15px;

    .title {
      height: 21px;
      font-size: 15px;
      font-weight: bold;
      line-height: 21px;
    }
    .toAll {
      height: 20px;
      font-size: 14px;
      font-weight: 500;
      line-height: 20px;
      display: flex;
      align-items: center;
    }
  }
  .address {
    padding-left: 0rpx;
  }
  .more-btn {
    font-size: 10px;
    color: #333333;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 15px;
    background-color: #fff;
    &:active {
      filter: brightness(95%);
    }
    .img {
      width: 20px;
      margin-right: 10px;
    }
  }
}
.address {
  padding-left: 0rpx;
}
.more-btn {
  font-size: 12px;
  color: #333333;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 15px;
  background-color: #fff;
  &:active {
    filter: brightness(95%);
  }
}
.address {
  padding-left: 0rpx;
}
.more-btn {
  font-size: 40px;
  color: #333333;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 65px;
  background-color: #fff;
  &:active {
    filter: brightness(95%);
  }
  .img {
    width: 50px;
    margin-right: 50px;
  }
}
</style>
